/**
 * ============================================================================
 * useAuditDetailQuery — Phase 7 frontend
 * Owner: Phase 7 — Internal Audit Programme Module.
 * Purpose: TanStack Query hook returning the AuditDetail projection.
 * Endpoint: GET /api/v1/audits/{id}
 * URS rows: INA-003, INA-005.
 * ============================================================================ */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';
import type { AuditDetailDto } from '../AuditCalendar/types';

export function useAuditDetailQuery(
  auditId: string | undefined,
): UseQueryResult<AuditDetailDto, Error> {
  return useQuery<AuditDetailDto, Error>({
    queryKey: ['internal-audit', 'audit-detail', auditId],
    queryFn: () => apiFetch<AuditDetailDto>(`/api/v1/audits/${encodeURIComponent(auditId!)}`),
    enabled: Boolean(auditId),
    staleTime: 15_000,
  });
}
